import { MoreActions } from "@zfp-akademie-a-s/zfp-design";
import { DocumentIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { MailIcon } from "Components/_Shared/Icons/Icons";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";
import { QuestionnairePdfEmailConfirmModal } from "./QuestionnairePdfEmailConfirmModal";
import { type QuestionnairePdfType, useQuestionnairePdf } from "./useQuestionnairePdf";

export const QuestionnaireMoreActions = () => {
  const { t } = useResource();
  const [confirmType, setConfirmType] = useState<QuestionnairePdfType | null>(null);
  const { clientEmail, isSending, sendPdf, openPreview } = useQuestionnairePdf();
  const isSendDisabled = !clientEmail || isSending.empty;

  return (
    <>
      <MoreActions
        label={t(Resources.Questionnaire.MoreActions.Title)}
        items={[
          {
            label: t(Resources.Questionnaire.MoreActions.ShowPdf),
            icon: <DocumentIcon />,
            onClick: () => openPreview("empty"),
          },
          {
            label: t(Resources.Questionnaire.MoreActions.SendEmail),
            icon: <MailIcon />,
            disabled: isSendDisabled,
            disabledReason: !clientEmail ? t(Resources.Questionnaire.Evaluation.SendPdf.EmailInvalid) : undefined,
            onClick: () => setConfirmType("empty"),
          },
        ]}
      />

      <QuestionnairePdfEmailConfirmModal
        type={confirmType}
        clientEmail={clientEmail}
        onClose={() => setConfirmType(null)}
        onConfirm={sendPdf}
      />
    </>
  );
};
